<script lang="ts" setup>
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import Pagination2 from '@/components/Slider/Pagination2.vue'
import SectionTitle from '@/components/Title/SectionTitle.vue'
import type { Image } from '@/utils/types/Image'
const props = defineProps({
  highlights: {
    type: Array as PropType<Array<Image>>,
    default: []
  }
})

SwiperCore.use([Autoplay, Pagination])

const currentIndex: Ref<number> = ref(0)

const swiperSlideSelector = ref()
const onSwiper = (data: any) => {
  //存放 swiper
  swiperSlideSelector.value = data
}

const swiperTo = (index: number) => {
  swiperSlideSelector.value.slideTo(index)
}

const handelSwiperChange = (data: any) => {
  currentIndex.value = data.realIndex
  // swiperSlideSecondSelector.value.slideTo(data.realIndex)
}

const handlePaginationChange = (index: number) => {
  swiperTo(index)
  currentIndex.value = index
}
</script>

<template>
  <div class="slide">
    <SectionTitle class="slide__sectionTitle">活動花絮</SectionTitle>
    <div class="slide__swiper">
      <swiper :autoplay="{
        delay: 3000
      }" :slidesPerView="'auto'" :spaceBetween="24" :speed="300" :loop="true" class="swiper-list" @swiper="onSwiper"
        @slide-change="handelSwiperChange">
        <!-- @swiper="onSwiper" -->
        <swiper-slide v-for="(item, index) in highlights" :key="index">
          <div class="swiper-list__box">
            <figure class="swiper-list__pic">
              <Nimg :src="item.link" :alt="item?.alt" :title="item?.title" />
            </figure>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="pagination">
      <Pagination2 :currentIndex="currentIndex" @update:change="handlePaginationChange" :totalIndex="highlights.length" />
      <!-- <div class="pagination__bottom">
        照片下載
        <button class="pagination__bottom__button">
          <svg-icon name="icon-download"></svg-icon>
        </button>
      </div> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.slide {
  @include grid(8, 24);

  @include max-media(990) {
    @include grid(4, 24);
  }

  &__sectionTitle {
    grid-column: 2 / span 7;
    margin-bottom: toRem(25);

    @include max-media(990) {
      grid-column: 1 / span 4;
    }
  }

  &__swiper {
    grid-column: 1 / span 8;
    margin-right: toRem(-24);

    @include max-media(990) {
      grid-column: 1 / span 4;
    }
  }
}

.swiper-slide {
  width: auto;
}

.pagination {
  grid-column: 1 / span 8;
  padding-top: toRem(20);
  padding-bottom: toRem(30);

  @include max-media(990) {
    grid-column: 1 / span 4;
  }

  &__bottom {
    display: flex;
    align-items: center;
    font-weight: 700;
    padding-top: toRem(20);
    font-size: toRem(16);
    color: $color-gray-1;

    &__button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: toRem(28);
      height: toRem(28);
      margin-left: toRem(24);
      border-radius: 50%;
      border: 1px solid $color-gray-line;
      color: $color-gray-1;
    }
  }
}
</style>
